import { FC } from 'react';

import styles from 'components/Header/TopBar/TopBar.module.scss';
import { TopBarPhoneInterface } from 'components/Header/TopBar/declarations';
import { CTMNumber } from 'entities/CTMPhone';
import { DataLink } from 'components/Shared/SharedComponents';
import { GAReplacementValue } from 'constants/enums';

const commonProps = {
  className: styles.topBarPhonesHelpPhone,
};

const TopBarPhone: FC<TopBarPhoneInterface> = ({
  title,
  link,
  isLastElem,
}) => {
  const number = link?.src?.substring(4) || title;

  if (isLastElem) {
    return (
      <CTMNumber
        id="DynamicPhone"
        number={number!}
        link={link!}
        {...commonProps}
      />
    );
  }

  if (!link) {
    return (
      <DataLink
        href={`tel:${number}`}
        gaData={{ [GAReplacementValue.TELEPHONE]: title! }}
        {...commonProps}
      >
        {number}
      </DataLink>
    );
  }

  return (
    <DataLink
      link={link}
      gaData={{ [GAReplacementValue.TELEPHONE]: link.src?.substring(4) }}
      {...commonProps}
    >
      {number}
    </DataLink>
  );
};

export default TopBarPhone;
